export const findCityByPathSegment = (cities, segment) => {
  if (!segment || !cities?.length) {
    return null;
  }

  const normalized = segment.toLowerCase();
  return cities.find(city => city._supertag?.toLowerCase() === normalized) || null;
};

export const stripDuplicateCityPrefix = (pathname, cities) => {
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length < 2) {
    return pathname;
  }

  const firstCity = findCityByPathSegment(cities, segments[0]);
  const secondCity = findCityByPathSegment(cities, segments[1]);

  if (firstCity && secondCity && firstCity.id !== secondCity.id) {
    segments.shift();
    return `/${segments.join('/')}`;
  }

  return pathname;
};
